<div class="scoring_block" (click)="showSettingsForm()">
  <div class="edit_link">Settings</div>
  <h4>Prioritization</h4>
  <p>{{modeName}}</p>
</div>

